import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import { UserProvider } from '@nexus/fff-utilities';
import { MyBoxProvider } from '@nexus/fff-box';
import { initialize } from '@nexus/fff-analytics';
import App from './App';
import reportWebVitals from './reportWebVitals';

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_CONTAINER_ID,
};

TagManager.initialize(tagManagerArgs);
initialize().then();
ReactDOM.render(
  <React.StrictMode>
    <UserProvider>
      <MyBoxProvider>
        <App />
      </MyBoxProvider>
    </UserProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
